import { useQuery } from "urql";
import { graphql } from "../gql";

export const profileQuery = graphql(`
  query profileQuery($id: ID) {
    profile(id: $id) {
      id
      firstName
      lastName
    }
  }
`);

export function useProfileQuery(id?: string, pause = false) {
  const [result, reexecuteQuery] = useQuery({
    query: profileQuery,
    variables: { id: id ?? null },
    pause,
  });

  return {
    profile: result.data?.profile,
    fetching: result.fetching,
    error: result.error,
    reexecuteQuery,
  };
}
